<p>{{componentConfig?.idFieldName}}</p>
